// Constants
import {
  BACKGROUND_DOCUMENT_HIDDEN_CUSTOM_ACTION,
  BACKGROUND_DOCUMENT_VISIBLE_CUSTOM_ACTION,
} from './constants/background-log.handlers.utils.constants';
import {
  PERFORMANCE_ENTRY_ID,
  RELOAD_TYPE_MODERN,
} from './constants/background.handlers.utils.constants';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import { BackgroundHandlersBuilderType } from '../types/background.handlers.type';

const getCustomActionAccordingVisibility = (visible: boolean): string =>
  visible ? BACKGROUND_DOCUMENT_VISIBLE_CUSTOM_ACTION : BACKGROUND_DOCUMENT_HIDDEN_CUSTOM_ACTION;

const isBackgroundWhiteListedFlow = (
  currentState: BackgroundHandlersBuilderType['currentState']
): boolean =>
  [
    AppStatesEnumeration.CHECKOUT_BIZUM,
    AppStatesEnumeration.CHECKOUT_DOWNPAYMENT,
    AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING,
  ].includes(currentState);

const hasReloadPerformanceModernNavigationEntry = (): boolean =>
  (performance.getEntriesByType(PERFORMANCE_ENTRY_ID)[0] as PerformanceNavigationTiming).type ===
  RELOAD_TYPE_MODERN;

const hasReloadPerformanceLegacyNavigationEntry = (): boolean =>
  window.performance &&
  'navigation' in window.performance &&
  window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD;

const hasReloadPerformanceEntry = (): boolean =>
  hasReloadPerformanceModernNavigationEntry() || hasReloadPerformanceLegacyNavigationEntry();

export {
  hasReloadPerformanceEntry,
  getCustomActionAccordingVisibility,
  isBackgroundWhiteListedFlow,
};
